module.exports = __webpack_public_path__ + "static/media/helsinki-logo.032dc714.png";